import React, { SVGProps } from 'react'
const SvgEmptyStateChartGrayscale = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={83}
    height={80}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <rect
      width={14.911}
      height={4.103}
      fill="#EAEBF1"
      rx={1.207}
      transform="matrix(-1 0 0 1 79.91 15)"
    />
    <rect
      width={34.911}
      height={4.103}
      fill="#EAEBF1"
      rx={1.207}
      transform="matrix(-1 0 0 1 79.91 60)"
    />
    <rect
      width={24.911}
      height={4.103}
      fill="#EAEBF1"
      rx={1.207}
      transform="matrix(-1 0 0 1 26.91 52)"
    />
    <g filter="url(#Empty-State-Chart-Grayscale_svg__a)">
      <ellipse cx={43.5} cy={39} fill="#fff" rx={34.5} ry={35} />
    </g>
    <g filter="url(#Empty-State-Chart-Grayscale_svg__b)">
      <path
        fill="url(#Empty-State-Chart-Grayscale_svg__c)"
        d="M11.5 43.69c0-.696.564-1.26 1.26-1.26h10.08c.696 0 1.26.564 1.26 1.26V67H11.5V43.69Z"
      />
    </g>
    <g filter="url(#Empty-State-Chart-Grayscale_svg__d)">
      <path
        fill="url(#Empty-State-Chart-Grayscale_svg__e)"
        d="M28.51 24.79c0-.696.564-1.26 1.26-1.26h10.08c.696 0 1.26.564 1.26 1.26V67h-12.6V24.79Z"
      />
    </g>
    <g filter="url(#Empty-State-Chart-Grayscale_svg__f)">
      <path
        fill="url(#Empty-State-Chart-Grayscale_svg__g)"
        d="M44.89 34.87c0-.696.564-1.26 1.26-1.26h10.08c.696 0 1.26.564 1.26 1.26V67h-12.6V34.87Z"
      />
    </g>
    <g filter="url(#Empty-State-Chart-Grayscale_svg__h)">
      <path
        fill="url(#Empty-State-Chart-Grayscale_svg__i)"
        d="M61.9 15.34c0-.696.564-1.26 1.26-1.26h10.08c.696 0 1.26.564 1.26 1.26V67H61.9V15.34Z"
      />
    </g>
    <defs>
      <filter
        id="Empty-State-Chart-Grayscale_svg__a"
        width={79}
        height={80}
        x={4}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={2.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_316"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_316"
          result="shape"
        />
      </filter>
      <filter
        id="Empty-State-Chart-Grayscale_svg__b"
        width={18.9}
        height={30.87}
        x={8.35}
        y={39.91}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.63} />
        <feGaussianBlur stdDeviation={1.575} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0862449 0 0 0 0 0.369598 0 0 0 0 0.799349 0 0 0 0.2 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_316"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_316"
          result="shape"
        />
      </filter>
      <filter
        id="Empty-State-Chart-Grayscale_svg__d"
        width={18.9}
        height={49.77}
        x={25.36}
        y={21.01}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.63} />
        <feGaussianBlur stdDeviation={1.575} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0862449 0 0 0 0 0.369598 0 0 0 0 0.799349 0 0 0 0.2 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_316"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_316"
          result="shape"
        />
      </filter>
      <filter
        id="Empty-State-Chart-Grayscale_svg__f"
        width={17.64}
        height={38.43}
        x={42.37}
        y={33.61}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2.52} />
        <feGaussianBlur stdDeviation={1.26} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.411765 0 0 0 0 0.439216 0 0 0 0 0.501961 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_316"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_316"
          result="shape"
        />
      </filter>
      <filter
        id="Empty-State-Chart-Grayscale_svg__h"
        width={18.9}
        height={59.22}
        x={58.75}
        y={11.56}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.63} />
        <feGaussianBlur stdDeviation={1.575} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0862449 0 0 0 0 0.369598 0 0 0 0 0.799349 0 0 0 0.2 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_316"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_316"
          result="shape"
        />
      </filter>
      <linearGradient
        id="Empty-State-Chart-Grayscale_svg__c"
        x1={10.1}
        x2={33.298}
        y1={68.72}
        y2={57.331}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#697080" />
        <stop offset={1} stopColor="#DADBE0" />
      </linearGradient>
      <linearGradient
        id="Empty-State-Chart-Grayscale_svg__e"
        x1={27.11}
        x2={53.841}
        y1={70.043}
        y2={62.625}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#697080" />
        <stop offset={1} stopColor="#DADBE0" />
      </linearGradient>
      <linearGradient
        id="Empty-State-Chart-Grayscale_svg__g"
        x1={57.49}
        x2={77.603}
        y1={27.61}
        y2={40.203}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#697080" />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="Empty-State-Chart-Grayscale_svg__i"
        x1={60.5}
        x2={87.867}
        y1={70.704}
        y2={64.466}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#697080" />
        <stop offset={1} stopColor="#DADBE0" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgEmptyStateChartGrayscale
